<template>
  <vx-card title="Department Type">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getAllDepartment"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Division</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].departmentId">
                      {{ data[indextr].departmentId }}
                    </vs-td>
                    <vs-td :data="data[indextr].departmentCode">
                      {{ data[indextr].departmentCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].departmentName">
                      {{ data[indextr].departmentName }}
                    </vs-td>
                    <vs-td :data="data[indextr].divisionId">
                      {{ divisionLabel(data[indextr].divisionId) }}
                    </vs-td>
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].departmentId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].departmentId)
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD DEPARTMENT TYPE -->
      <vs-prompt
        class="email-compose"
        title="Add Type of Department"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="department.departmentCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="department.departmentName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Division</span>
              <v-select
                v-model="selectedDivision"
                label="divisionName"
                :options="getAllDivision"
                placeholder="Please Select"
              />
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ADD DEPARTMENT TYPE -->

      <!-- EDIT DEPARTMENT TYPE -->
      <vs-prompt
        class="email-compose"
        title="Edit Department Type"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="department.departmentCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="department.departmentName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Division</span>
              <v-select
                v-model="selectedDivision"
                label="divisionName"
                :options="getAllDivision"
                placeholder="Please Select"
              />
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT DEPARTMENT TYPE  -->
    </div>
  </vx-card>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      department: {
        departmentId: 0,
        departmentCode: "",
        departmentName: "",
        divisionId: null,
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllDepartment").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllDivision").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getAllDepartment() {
      return this.$store.state.lookup.getAllDepartment;
    },
    getAllDivision() {
      return this.$store.state.lookup.getAllDivision;
    },
    selectedDivision: {
      get() {
        return this.$store.getters["lookup/division"](this.department.divisionId);
      },
      set(division) {
        this.department.divisionId = division ? division.divisionId : null;
      },
    },
    validForm() {
      return Boolean(
        this.department.departmentCode && this.department.departmentName
      );
    },
  },
  methods: {
    divisionLabel(divisionId) {
      const division = this.$store.getters["lookup/division"](divisionId);
      return division ? division.divisionName : "None";
    },
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addDepartment", this.department)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/department"](id);

      (this.department.departmentId = id),
        (this.department.departmentCode = e.departmentCode),
        (this.department.departmentName = e.departmentName),
        (this.department.divisionId = e.divisionId),
        (this.activePromptEditRecord = true);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateDepartment", this.department)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
